import React from 'react';

const ProgressCell = ({ progress }) => {
  return <span>{`${progress.toFixed(1)}%`}</span>;
};

export default ProgressCell;
